export { InputTax } from './InputTax';
